<template>
<div class="wrapper" style="background:white;">
  <div class="search-header">
    <div class="search-header-text">我的订阅</div>
  </div>

  <div class="Push-article-box article-a" >

    <div class="Push-article-list" v-for="item in subscribeList">
      <div class="head-title" @click="goMessagePage(item), setCnzz('我的订阅', '点击查看我的订阅内容', '')">
       {{item.name}}
       </div>

    </div>
  </div>
  <div class="ubscribe-news-no" v-if="loading">
    <div class="ubscribe-news-no-cont">
     <img src="../../static/images/loading2.gif">
     </div>
  </div>
  <div class="ubscribe-news-no" v-if="!loading && subscribeList.length == 0">
    快到网页端订阅资讯吧
  </div>

  <!-- <div v-if="loading">正在加载中...</div> -->
  <!-- <div v-if="!loading">已全部加载</div> -->
</div>
</template>
<script>
import $ from 'jquery'
import {apiUrl, alert} from '../helper'
import userMix from '../common/userMix'
import searchMix from '../common/SearchMix'
import comsearchMix from '../common/comSearchMix'
import wxshareMix from '../common/wxshareMix'
export default {
  mixins: [userMix, searchMix, comsearchMix, wxshareMix],
  data () {
    return {
      subscribeList: [],
      loading: true
    }
  },
  route: {
    data ({ to }) {
      document.title = '我的订阅'
      if (!this.currentuser) {
        this.wxcode = this.getQueryString('code')  // 获取微信登录code
        if (this.wxcode) {
          this.wxlogin(this.wxcode)
        } else {
          this.getProfile('weixin')
        }
      }
      if (this.currentuser) {
        this.getProfile('weixin')
        if (this.currentuser.regtyp == 4 ) {
          // 绑定账号
          this.goBindPage(1)
          return false
        }
        if (this.currentuser.mp == 0 || !this.currentuser.weixin) {

            let appid = this.$config.weixin.appid
            this.currentuser = null
            let redirectUri = encodeURIComponent(window.location.href)
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'

            return false


        }
        if (!this.checkPrivilege('user/event', '暂无权限')) {
          return false
        }
        this.getAllsubscribe()
        // this.getStype()
      }

    }
  },
  methods: {
    // 获取所有订阅
    getAllsubscribe: function () {
      // this.loading = true
      $.ajax({
        url: apiUrl('/V1.0.0/user/eventlist'),
        method: 'post',
        dataType: 'json'
      }).done((response) => {
        this.loading = false
        if (response.status == 0) {
          this.subscribeList = []
          for (let item of response.data) {
            this.subscribeList.push(item)
          }

        } else {
          alert(response.description)
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
      })
    },
    goMessagePage: function (item) {
      this.$route.router.go({path: '/newmessage', query: {'name': item.name, 'id': item.id}})
    },
    setCnzz (name, action, label) {
      window._czc.push(['_trackEvent', name, action, label])
      console.log(name + ' : ' + action + ' : ' + label)
    }
    // getMsg: function (id) {
    //   this.loading = true
    //   var query = {'eventid': id, 'page': this.page, 'perPage': 10}
    //   $.ajax({
    //     url: apiUrl('/V1.0.0/user/eventmsg'),
    //     method: 'post',
    //     dataType: 'json',
    //     data: JSON.stringify(query)
    //   }).done((response) => {
    //     this.loading = false
    //     if (response.status == 0) {
    //       this.eventmsg = response.lists
    //     } else {
    //       alert(response.description)
    //     }
    //   }).fail((response) => {
    //     this.loading = false
    //     alert('请求失败')
    //   })
    // }
  }
}
</script>



/** WEBPACK FOOTER **
 ** MySubscribe.vue?2c9d85aa
 **/